const pagesIndividualCertificationsEn = {
  headers: {
    certificationKind: 'Kind',
    expireAt: 'Valid Until',
    lastUpdated: 'Last Renewed',
    name: 'Certification',
    number: 'Certificate No.',
    renewBy: 'Renewal Deadline'
  },
  pageTitle: 'Certifications',
  tabs: {
    self: 'My Certifications'
  }
};
export default pagesIndividualCertificationsEn;